const firebaseConfig = {
  apiKey: "AIzaSyDdF2a72mfHB4BgLqY_sA2jHiUCoHq-DxQ",
  authDomain: "nwzz-tourpacker.firebaseapp.com",
  projectId: "nwzz-tourpacker",
  storageBucket: "nwzz-tourpacker.appspot.com",
  messagingSenderId: "751077636736",
  appId: "1:751077636736:web:028e2e7836e5c57ca00465"
  };
  export default firebaseConfig;